type Environment = 'development' | 'production';

interface AppConfig {
    BASE_URL: string;
    API_VERSION: string;
    PROJECT_NAME: string;
    ENABLE_DEPOSIT_FEATURE: boolean;
    ENABLE_WITHDRAWAL_FEATURE: boolean;
    SUPPORT_EMAIL: string;
    LOG_LEVEL: 'debug' | 'info' | 'warn' | 'error';
}

const ENV =  'production'; // Change to 'production' for production environment

const configs: Record<Environment, AppConfig> = {
    development: {
        BASE_URL: 'https://mwmbl4vb-5005.inc1.devtunnels.ms',
        API_VERSION: '/v1/admin',
        PROJECT_NAME: 'SwiftRamp Dev',
        ENABLE_DEPOSIT_FEATURE: true,
        ENABLE_WITHDRAWAL_FEATURE: true,
        SUPPORT_EMAIL: 'support-dev@swiftramp.in',
        LOG_LEVEL: 'debug',
    },

    production: {
        BASE_URL: 'https://sudo.swiftramp.in',
        API_VERSION: '/v1/admin',
        PROJECT_NAME: 'SwiftRamp',
        ENABLE_DEPOSIT_FEATURE: true,
        ENABLE_WITHDRAWAL_FEATURE: false,
        SUPPORT_EMAIL: 'support@swiftramp.in',
        LOG_LEVEL: 'error',
    },
};

export const appConfig =  configs.production;